<div class="_mx-auto sm:_ml-0 _bg-grayscale-white"
    [ngClass]="useFixedImageSize && '_h-host-logo-sm sm:_h-host-logo-lg _w-host-logo-sm sm:_w-host-logo-lg'">

    <img app-imagekit *ngIf="imageUrl && useFixedImageSize" [source]="imageUrl" transform="tr:w-272" class="_h-full _w-full _object-contain">

    <img app-imagekit
        class=""
        *ngIf="imageUrl && !useFixedImageSize"
        [source]="imageUrl"
        [style]="'width: ' + imageWidth + 'px; height: ' + imageHeight + 'px;'"
        transform="tr:w-{{(imageWidth * 2) || 160}},h-{{(imageHeight * 2) || 160}},cm-pad_resize,bg-FFFFFF">

    <div *ngIf="!imageUrl" class="_placeholder _w-full _h-full _center-xy">
        <app-initials [displayName]="displayName"></app-initials>
    </div>

</div>
